import { Component, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { EventsService } from '../../services/events.service';
import { NavigationEnd, NavigationStart, Router} from '@angular/router';
import { WordpressService } from '../../services/wordpress.service';
declare var $: any;

@Component({
  selector: 'app-scroll-text',
  templateUrl: './scroll-text.component.html',
  styleUrls: ['./scroll-text.component.scss']
})
export class ScrollTextComponent implements AfterViewInit, OnDestroy {
  @Input() scrollText: string;
  @Input() outsideZone = false;
  $window;
  $scrollText;
  $hidden;
  textPosition = -20;
  lastScrollTop = 0;
  routerSubscription;
  spotifyURL;
  scrollStarted = false;
  marquee;
  anchor;
  isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  constructor(
    private el: ElementRef,
    private wps: WordpressService,
    private router: Router,
    private events: EventsService
  ) {
    this.wps.getContact().subscribe((res) => {
      this.spotifyURL = res && res.acf ? res.acf.spotify_playlist_url : '';
    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.destroyScroller();
      }

      if (event instanceof NavigationEnd) {
        this.resetScroller();
      }
    });
  }

  isTextInView() {
    const elementTop = this.$scrollText.offset().top;
    const elementBottom = elementTop + this.$scrollText.outerHeight();
    const viewportTop = this.$window.scrollTop();
    const viewportBottom = viewportTop + this.$window.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  addText(text) {
    let textWidth;

    if (this.$hidden) {
      this.$hidden.text(text);
      textWidth = this.$hidden.width();
      const numTextRepeats = Math.ceil((this.$window.width() * 5) / textWidth);
      const spotifyLink = "<a class='scroll-text__link' aria-label='Link opens to a Spotify link with audio' target='_blank' href='" + this.spotifyURL + "'> Noise </a>";

      let _text = text === 'Noise' ? spotifyLink : text;

      for (let i = 0; i < numTextRepeats; i++) {
        if (text === 'Noise') {
          _text += (i + 1) % 4 === 0 ? spotifyLink : ' Voice';
        } else {
          _text += ' ' + text;
        }
      }

      if (this.$scrollText) {
        this.$scrollText.html(_text);
      }
    }
  }

  resetScroller() {
    if (this.scrollText && !this.isSafari) {
      this.getElements();
      this.addText(this.scrollText);
      this.textPosition = -40;
    }
  }

  moveScrollText() {
    const newScrollTop = this.$window.scrollTop();
    const downwardScroll = !this.outsideZone ? newScrollTop > this.lastScrollTop : newScrollTop >= this.lastScrollTop;
    this.lastScrollTop = newScrollTop;

    if (this.isTextInView()) {
      if (downwardScroll) {
        this.textPosition -= this.outsideZone ? 7 : 10;
      } else {
        this.textPosition += this.outsideZone ? 20 : 10;
      }

      if (this.textPosition > -20) {
        this.textPosition -= 20;
      }

      this.$scrollText.css('transform', 'translateX(' + this.textPosition + 'px)');
    }
  }

  destroyScroller() {
    if (this.scrollStarted && this.marquee) {
      this.scrollStarted = false;
      this.marquee.marquee('destroy');
    }
  }

  initScroller() {
    if (this.scrollText && !this.isSafari) {
      this.addText(this.scrollText);
    }

    if (!this.isSafari) {
      this.events.on('window:scroll', () => {
        this.moveScrollText();
      });
    } else {
      this.scrollText = (`${this.scrollText} `).repeat(5);

      if (!this.scrollStarted) {
        this.scrollStarted = true;
        setTimeout(() => {
          this.marquee = $('.marquee', this.el.nativeElement).marquee({
            duration: 7000,
            gap: 25,
            delayBeforeStart: 0,
            direction: 'left',
            startVisible: true,
            duplicated: true
          });
        }, this.outsideZone ? 2000 : 0);
      }
    }
  }

  getElements() {
    this.$window = $(window);
    this.$scrollText = $('[data-text]', this.el.nativeElement);
    this.$hidden = $('[data-hidden-text]', this.el.nativeElement);
  }

  ngAfterViewInit() {
    this.anchor = window.location.pathname.replace('/', '');

    // On intro activation
    this.events.on('route:change', ({ path, intro }) => {
      if (intro) {
        this.initScroller();
      }
    });

    // If deep-linking
    if (this.anchor !== '') {
      this.getElements();
      this.initScroller();
    } else {
      setTimeout(() => {
        this.getElements();
      }, 0);
    }
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }
}
